var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import * as React from "react";
import { Select } from "./select";
import { componentTranslations } from "./i18n/index";
import { FlexContainer } from "../grid/flexcontainer";
import { bind } from "decko";
import Button from "./button";
import { Grid } from "../grid/grid";
import Form from "./form";
import { isNullOrUndefined } from "../better/utils";
export class Pager extends React.Component {
    constructor(props) {
        super(props);
    }
    onPageSelect(value) {
        this.props.onChange &&
            this.props.onChange(parseInt(value), this.props.page.limit);
    }
    onLimitSelect(value) {
        const page = this.props.page;
        const newLimit = parseInt(value);
        const newPage = Math.min(page.page, this.numberOfPages(page.total, newLimit));
        this.props.onChange && this.props.onChange(newPage, newLimit);
    }
    onFirst(event) {
        this.props.onChange && this.props.onChange(1, this.props.page.limit);
    }
    onPrev(event) {
        this.props.onChange &&
            this.props.onChange(this.props.page.page - 1, this.props.page.limit);
    }
    onNext(event) {
        this.props.onChange &&
            this.props.onChange(this.props.page.page + 1, this.props.page.limit);
    }
    onLast(event) {
        const numberOfPages = this.numberOfPages(this.props.page.total, this.props.page.limit);
        this.props.onChange &&
            this.props.onChange(numberOfPages, this.props.page.limit);
    }
    numberOfPages(total, limit) {
        return total === 0 ? 1 : Math.ceil(total / limit);
    }
    render() {
        const { page, limits } = this.props;
        const translate = componentTranslations();
        const numberOfPages = this.numberOfPages(page.total, page.limit);
        const pageOptions = [];
        const limitOptions = (limits || [10, 20, 50]).map((limit) => ({
            value: limit.toString(),
            label: limit.toString(),
        }));
        const adjustableLimit = isNullOrUndefined(this.props.adjustableLimit)
            ? true
            : this.props.adjustableLimit;
        for (let i = 1; i <= numberOfPages; i++) {
            pageOptions.push({ value: i.toString(), label: i.toString() });
        }
        return (React.createElement(FlexContainer, { "xs-justify": "end", spaceBetween: "xxl", flexWrap: "nowrap" },
            React.createElement(FlexContainer, { canGrow: false, spaceBetween: "md", "md-align": "center" },
                React.createElement("span", null, translate.pager.page),
                React.createElement(Form, null,
                    React.createElement(Select, { size: "small", value: page.page.toString(), options: pageOptions, onValueChange: this.onPageSelect })),
                adjustableLimit && React.createElement("span", null, translate.pager.linesPerPage),
                adjustableLimit && (React.createElement(Form, null,
                    React.createElement(Select, { size: "small", value: page.limit.toString(), options: limitOptions, onValueChange: this.onLimitSelect })))),
            React.createElement(Grid, { columns: 4, gap: "md" },
                React.createElement(Button, { icon: "paging_first", type: "tertiary", disabled: page.page === 1, onClick: this.onFirst }),
                React.createElement(Button, { icon: "paging_prev", type: "tertiary", disabled: page.page === 1, onClick: this.onPrev }),
                React.createElement(Button, { icon: "paging_next", type: "tertiary", disabled: page.page === numberOfPages, onClick: this.onNext }),
                React.createElement(Button, { icon: "paging_last", type: "tertiary", disabled: page.page === numberOfPages, onClick: this.onLast }))));
    }
}
__decorate([
    bind,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], Pager.prototype, "onPageSelect", null);
__decorate([
    bind,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], Pager.prototype, "onLimitSelect", null);
__decorate([
    bind,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Pager.prototype, "onFirst", null);
__decorate([
    bind,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Pager.prototype, "onPrev", null);
__decorate([
    bind,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Pager.prototype, "onNext", null);
__decorate([
    bind,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Pager.prototype, "onLast", null);
export default Pager;
//# sourceMappingURL=pager.js.map